export const streamSkeletonStyles = (theme) => {
  return {
    root: {
      position: 'relative',
      padding: '0px !important',
      margin: '0px !important',
      // height: '100%',
      width: '100%',
      backgroundColor: 'rgb(43, 44, 51)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden !important',
      overflowY: 'hidden',
      overflowX: 'hidden',
    },
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      animation: `$myEffect 2800ms infinite ${theme.transitions.easing.easeInOut} `,
    },
    // animatedItemExiting: {
    //     animation: `$myEffectExit 3000ms ${theme.transitions.easing.easeInOut}`,
    //     opacity: 0,
    //     // transform: "translateY(-200%)"
    //   },
    '@keyframes myEffect': {
      '0%': {
        opacity: 1,
      },
      '10%': {
        opacity: 0.8,
      },
      '20%': {
        opacity: 0.6,
      },
      '30%': {
        opacity: 0.4,
      },
      '40%': {
        opacity: 0.2,
      },
      '50%': {
        opacity: 0.2,
      },
      '60%': {
        opacity: 0.4,
      },
      '70%': {
        opacity: 0.6,
      },
      '85%': {
        opacity: 0.8,
      },
      '90%': {
        opacity: 1,
      },
    },

    leftContainer: {
      width: '50%',
      height: '100%',
      // backgroundColor: 'yellow',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-evenly',
    },
    liveScreen: {
      height: '45%',
      width: '95%',
      backgroundColor: '#1C2833',
      opacity: 0.6,
      borderRadius: '15px',
    },
    comment: {
      height: '45%',
      width: '95%',
      backgroundColor: '#6e6e6e',
      borderRadius: '15px',
      opacity: 0.4,
    },
    rightContainer: {
      width: '50%',
      height: '100%',
      display: 'grid',
      placeItems: 'center',
      // backgroundColor: 'green',
    },
    videoChat: {
      backgroundColor: '#000000',
      borderRadius: '15px',
      opacity: 0.25,
      width: '95%',
      height: '80%',
      // margin: '20px',
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center'
    },
    footerContainer: {
      width: '100%',
      height: '6%',
      display: 'grid',
      placeItems: 'center',
      animation: `$myEffect 2000ms infinite ${theme.transitions.easing.easeInOut} `,
    },
    footer: {
      backgroundColor: '#000000',
      opacity: 0.25,
      borderRadius: '10px',
      width: '99%',
      height: '85%',
    },
    webkitScrollbar: {
      display: 'none',
    },
  };
};
